import axios from "axios";
import TokenService from "./TokenService";


let getHeaderConfig = () =>
  process.env.VUE_APP_API_AUTH_HEADER
    ? {
        Authorization: process.env.VUE_APP_API_AUTH_HEADER
      }
    : {};

let config = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: getHeaderConfig()
};

let api = axios.create(config);


const ApiService = {
  setHeader: () =>
    (api.defaults.headers.common[
      "X-Authorization"
    ] = `Token ${TokenService.getToken()}`),

  removeHeader() {
    api.defaults.headers.common = getHeaderConfig();
  },

  get(resource, config={}) {
    return api.get(resource, config);
  },

  post(resource, data) {
    return api.post(resource, data);
  },

  put(resource, data) {
    return api.put(resource, data);
  },

  delete(resource) {
    return api.delete(resource);
  },

  customRequest(data) {
    return api(data);
  }
};

export default ApiService;
